import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import reviews from '../data/reviews';
import '../css/Reviews.css';
import '../css/GoogleReviews.css';

// Featured reviews first (by their order), then all the others
const carouselReviews = [
    ...reviews
        .filter(review => review.featured)
        .sort((a, b) => a.featured - b.featured),
    ...reviews.filter(review => !review.featured)
];

const GOOGLE_REVIEWS_URL = "https://www.google.com/search?hl=fr&authuser=0&uds=AOm0WdE2fekQnsyfYEw8JPYozOKzd_f15QZoBU42Y19e4AjyRjLeCvKc-aA7rIiMPsUTQrQyAPxdSyl_Rx1TFCizgBAYoDDky-0ZAU2FHbpXbKfq9fftVZLXPpdgJgOKHyu7QAsbMSsgJh2mSwxiGByd_uoLGVxWtQ&q=CC%20D%C3%A9barras%2014%20Avis&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E1SxqU_XPuIAB7aufDJgtUcz5JWEIo97bjaAZBBoZ6fcysPiCHCnzvuG1gvNVNIAH0ZvyDxvqkWfFtp3FByjtlJ3luFO&cs=1&sa=X&ved=0CB8Q_4MLahcKEwjwsojtj5yRAxUAAAAAHQAAAAAQBw&biw=1440&bih=699&dpr=2";

// Custom arrow for the carousel (slick passes onClick)
const CarouselArrow = ({ direction, onClick }) => (
    <button
        type="button"
        className={`reviews-arrow reviews-arrow-${direction}`}
        onClick={onClick}
        aria-label={direction === 'prev' ? 'Avis précédent' : 'Avis suivant'}
    >
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
            <path
                d={direction === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </button>
);

const GoogleReviews = () => {
    return (
        <div className="google-reviews-section">
            <h2>Les avis de nos clients</h2>
            <div className="google-reviews-rating">
                <span className="rating-stars">★★★★★</span>
                <span>5.0 • 14 avis clients</span>
            </div>
            <div className="google-reviews-carousel">
                <Slider
                    slidesToShow={1}
                    slidesToScroll={1}
                    autoplay={true}
                    autoplaySpeed={4000}
                    speed={600}
                    cssEase="cubic-bezier(0.4, 0, 0.2, 1)"
                    arrows={true}
                    prevArrow={<CarouselArrow direction="prev" />}
                    nextArrow={<CarouselArrow direction="next" />}
                    dots={true}
                    dotsClass="slick-dots reviews-dots"
                    customPaging={() => <span className="reviews-dot" />}
                    pauseOnHover={true}
                    infinite={true}
                    responsive={[
                        { breakpoint: 768, settings: { arrows: false } }
                    ]}
                >
                    {carouselReviews.map((review, index) => {
                        const content = (
                            <>
                                <span className="reviews-page-quote">”</span>
                                <div className="reviews-page-stars">
                                    {"★".repeat(review.rating)}
                                </div>
                                <p>{review.text}</p>
                                <div className="reviews-page-footer">
                                    <div className="reviews-page-avatar">
                                        {review.author_name.charAt(0)}
                                    </div>
                                    <div className="reviews-page-identity">
                                        <span className="reviews-page-author">{review.author_name}</span>
                                        <span className="reviews-page-source">Avis {review.source}</span>
                                    </div>
                                </div>
                            </>
                        );

                        return (
                            <div key={index} className="review-slide">
                                {review.source === "Google" ? (
                                    <a
                                        href={GOOGLE_REVIEWS_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="reviews-page-card review-card-link"
                                    >
                                        {content}
                                    </a>
                                ) : (
                                    <Link to="/nos-avis" className="reviews-page-card review-card-link">
                                        {content}
                                    </Link>
                                )}
                            </div>
                        );
                    })}
                </Slider>
            </div>
            <div className="reviews-actions">
                <Link to="/nos-avis" className="leave-review-button">
                    Voir tous les avis
                </Link>
                <Link to="/laisser-un-avis" className="leave-review-button">
                    Laisser un avis
                </Link>
            </div>
        </div>
    );
};

export default GoogleReviews;
